module.exports = __webpack_public_path__ + "img/melancolico.1384d4ab.svg";